/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { appSyncGraphQLApi } from '../../app/smorgAppSyncGraphQLApi';

export interface SmorgStudioProgrammesState {
  currentProgrammeId: string | null;
  currentPlanId: string | null;
  currentAddToPlannerDestination: string | null;
  currentAddToPlannerDestinationPlanId: string | null;
}

const initialState: SmorgStudioProgrammesState = {
  currentProgrammeId: null,
  currentPlanId: null,
  currentAddToPlannerDestination: null,
  currentAddToPlannerDestinationPlanId: null,
};

export const smorgStudioProgrammesSlice = createSlice({
  name: 'smorgStudioProgrammes',
  initialState,
  reducers: {
    addToPlannerDestinationChanged: (
      state,
      action: PayloadAction<string | null>,
    ) => {
      state.currentAddToPlannerDestination = action.payload;
    },
    addToPlannerDestinationPlanIdChanged: (
      state,
      action: PayloadAction<string | null>,
    ) => {
      state.currentAddToPlannerDestinationPlanId = action.payload;
    },
    currentProgrammeAndPlanChanged: (
      state,
      action: PayloadAction<{ programmeId: string; planId: string | null }>,
    ) => {
      const { programmeId, planId } = action.payload;
      state.currentProgrammeId = programmeId;
      state.currentPlanId = planId;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(appSyncGraphQLApi.util.resetApiState, (state) => {
      state.currentProgrammeId = null;
      state.currentPlanId = null;
      state.currentAddToPlannerDestination = null;
      state.currentAddToPlannerDestinationPlanId = null;
    });
  },
});

export const {
  addToPlannerDestinationChanged,
  addToPlannerDestinationPlanIdChanged,
  currentProgrammeAndPlanChanged,
} = smorgStudioProgrammesSlice.actions;

export default smorgStudioProgrammesSlice.reducer;
